export default "__VITE_ASSET__DtkrGZ_3__"